module.exports = __webpack_public_path__ + "img/TE-Lockup-RGB-BLACK.3db4c9ff.svg";